// src/pages/Mariage.js
import React from "react";
import { Link } from "react-router-dom";
import "../index.css";
import useSEO from "../seo/useSEO";

const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Photographie de mariage à Nancy",
    image: "https://www.hlbk.fr/images/services/mariage.jpg",
    
    provider: {
      "@type": "ProfessionalService",
      name: "HLBK Photo",
      url: "https://www.hlbk.fr/",
    },
    
    serviceType: "Photographie de mariage",
    areaServed: [
      {
        "@type": "City",
        name: "Nancy",
      },
      {
        "@type": "City",
        name: "Tomblaine",
      },
      {
        "@type": "AdministrativeArea",
        name: "Grand Nancy",
      },
      {
        "@type": "AdministrativeArea",
        name: "Grand Est",
      },
    ],
    url: "https://www.hlbk.fr/photographe-mariage-nancy",
    description:
      "Reportage photographique de mariage naturel et élégant à Nancy et dans le Grand Est.",
  };

export default function Mariage() {
  useSEO({
  title: "Photographe Mariage à Nancy | Reportage de Mariage — HLBK",
  description:
    "Photographe de mariage à Nancy et dans le Grand Est. Reportage naturel et vivant de votre journée : préparatifs, cérémonies, couple, vin d’honneur et soirée.",
  canonical: "https://www.hlbk.fr/photographe-mariage-nancy",
  image: "https://www.hlbk.fr/images/services/mariage.jpg",
  jsonLd: structuredData,
});

  return (
    <main className="wedding-page">

      {/* HERO */}
      <section
  className="wedding-hero"
  style={{
    backgroundImage: 'url("/images/services/mariage.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center 42%",
    backgroundRepeat: "no-repeat",
  }}
>
        <div className="wedding-hero-overlay" />

        <div className="wedding-container wedding-hero-content">
          <p className="wedding-kicker">
            PHOTOGRAPHE MARIAGE • NANCY & GRAND EST
          </p>

          <h1>
            Votre mariage.
            <span>Votre histoire, sans la rejouer.</span>
          </h1>

          <p className="wedding-lead">
            Des images naturelles, vivantes et élégantes pour raconter
            votre journée telle qu’elle a réellement été : les émotions,
            les gestes, les regards et tout ce qui se passe entre les moments attendus.
          </p>

          <div className="wedding-actions">
            <Link to="/contact" className="btn-cta btn-cta-red">
              PARLER DE VOTRE MARIAGE
            </Link>

            <a href="#wedding-approach" className="wedding-text-link">
              Découvrir mon approche ↓
            </a>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section id="wedding-approach" className="wedding-section">
        <div className="wedding-container wedding-intro">

          <p className="wedding-kicker">MON APPROCHE</p>

          <h2>
            Photographier votre mariage
            <span>sans transformer votre mariage en shooting.</span>
          </h2>

          <p className="wedding-intro-lead">
            Vous devez pouvoir vivre votre journée, pas passer votre temps
            à penser aux photographies.
          </p>

          <div className="wedding-intro-copy">
            <p>
              Je privilégie une approche discrète et attentive. J’observe,
              j’anticipe et j’interviens lorsqu’il est nécessaire de vous guider,
              tout en laissant une grande place au naturel.
            </p>

            <p>
              Les échanges entre vos proches, les gestes spontanés,
              la lumière d’un lieu, une émotion fugace ou un détail que vous
              n’aviez même pas remarqué font autant partie de votre histoire
              que les grands moments de la journée.
            </p>

            <p>
              Le résultat : un reportage cohérent et vivant, que vous pourrez
              redécouvrir dans quelques mois comme dans plusieurs années.
            </p>
          </div>

        </div>
      </section>

      {/* IMAGE FORTE */}
      <section className="wedding-feature-image">
        <img
          src="/images/services/mariage.jpg"
          alt="Reportage de mariage naturel à Nancy par HLBK"
          loading="lazy"
        />
      </section>

      {/* CE QUE JE PHOTOGRAPHIE */}
      <section className="wedding-section wedding-moments">
        <div className="wedding-container">

          <div className="wedding-heading">
            <p className="wedding-kicker">VOTRE JOURNÉE</p>

            <h2>
              Les grands moments.
              <span>Et surtout tout ce qu’il y a entre eux.</span>
            </h2>
          </div>

          <div className="wedding-moments-grid">

            <article>
              <span>01</span>
              <h3>Les préparatifs</h3>
              <p>
                L’ambiance qui monte doucement, les proches qui vous entourent,
                les détails et les premiers instants de la journée.
              </p>
            </article>

            <article>
              <span>02</span>
              <h3>Les cérémonies</h3>
              <p>
                Mairie, cérémonie religieuse ou laïque :
                les regards, les gestes et l’émotion sans interrompre le moment.
              </p>
            </article>

            <article>
              <span>03</span>
              <h3>Votre couple</h3>
              <p>
                Une séance simple et naturelle, idéalement lorsque la lumière
                est la plus belle, sans vous transformer en modèles.
              </p>
            </article>

            <article>
              <span>04</span>
              <h3>Vos proches</h3>
              <p>
                Des images vivantes de vos familles et amis,
                complétées par les photos de groupe importantes.
              </p>
            </article>

            <article>
              <span>05</span>
              <h3>Le vin d’honneur</h3>
              <p>
                Discussions, rires, détails et rencontres :
                beaucoup de souvenirs se créent justement à ce moment-là.
              </p>
            </article>

            <article>
              <span>06</span>
              <h3>La soirée</h3>
              <p>
                Discours, repas, première danse et piste de danse :
                une approche plus dynamique lorsque la journée s’accélère.
              </p>
            </article>

          </div>
        </div>
      </section>

      {/* GALERIE */}
      <section className="wedding-section wedding-gallery-section">
        <div className="wedding-container">

          <div className="wedding-heading">
            <p className="wedding-kicker">QUELQUES HISTOIRES</p>

            <h2>
              Des images qui ressemblent
              <span>à la journée que vous avez vécue.</span>
            </h2>
          </div>

          <div className="wedding-gallery">
            <img
              src="/images/mariage/mariage-01.jpg"
              alt="Photographe mariage Nancy"
              loading="lazy"
            />

            <img
              src="/images/mariage/mariage-02.jpg"
              alt="Reportage mariage naturel"
              loading="lazy"
            />

            <img
              src="/images/mariage/mariage-03.jpg"
              alt="Photo de couple mariage"
              loading="lazy"
            />

            <img
              src="/images/mariage/mariage-04.jpg"
              alt="Photographie cérémonie de mariage"
              loading="lazy"
            />

            <img
              src="/images/mariage/mariage-05.jpg"
              alt="Reportage mariage Grand Est"
              loading="lazy"
            />

            <img
              src="/images/mariage/mariage-06.jpg"
              alt="Photographie de mariage HLBK"
              loading="lazy"
            />
          </div>

        </div>
      </section>

      {/* PROCESS */}
      <section className="wedding-section wedding-process">
        <div className="wedding-container">

          <div className="wedding-heading">
            <p className="wedding-kicker">AVANT LE JOUR J</p>
            <h2>Tout commence par une conversation.</h2>
          </div>

          <div className="wedding-process-grid">

            <article>
              <span>01</span>
              <h3>On se rencontre</h3>
              <p>
                Nous échangeons autour de votre mariage, vos lieux,
                vos envies et ce qui compte particulièrement pour vous.
              </p>
            </article>

            <article>
              <span>02</span>
              <h3>On prépare</h3>
              <p>
                Horaires, déplacements et moments clés :
                nous construisons ensemble un déroulé simple.
              </p>
            </article>

            <article>
              <span>03</span>
              <h3>Vous profitez</h3>
              <p>
                Le jour J, mon objectif est que vous puissiez vivre
                votre mariage tout en sachant que les souvenirs sont là.
              </p>
            </article>

            <article>
              <span>04</span>
              <h3>Vous redécouvrez</h3>
              <p>
                Je sélectionne et travaille vos images avant de vous
                livrer votre reportage dans une galerie privée.
              </p>
            </article>

          </div>
        </div>
      </section>

      {/* TARIF */}
      <section className="wedding-section wedding-pricing">
        <div className="wedding-container wedding-pricing-inner">

          <p className="wedding-kicker">COLLECTIONS MARIAGE</p>

          <h2>
            Votre journée est unique.
            <span>Votre reportage doit l’être aussi.</span>
          </h2>

          <p className="wedding-price">
            à partir de <strong>850 € TTC</strong>
          </p>

          <p className="wedding-pricing-text">
            Le tarif dépend principalement du temps de présence,
            des lieux et des moments que vous souhaitez faire photographier.
            Chaque proposition est donc adaptée au déroulement de votre mariage.
          </p>

          <div className="wedding-included">
            <span>Reportage photographique</span>
            <span>Sélection & retouche</span>
            <span>Galerie privée</span>
            <span>Photographies HD</span>
          </div>

          <Link to="/contact" className="btn-cta btn-cta-red">
            RECEVOIR UNE PROPOSITION
          </Link>

        </div>
      </section>

      {/* LOCAL */}
      <section className="wedding-section wedding-local">
        <div className="wedding-container wedding-local-grid">

          <div>
            <p className="wedding-kicker">PHOTOGRAPHE MARIAGE À NANCY</p>

            <h2>
              Nancy, Grand Est
              <span>et bien au-delà.</span>
            </h2>
          </div>

          <div>
            <p>
              Basé à Tomblaine, près de Nancy, je photographie des mariages
              dans toute l’agglomération nancéienne et plus largement
              dans le Grand Est.
            </p>

            <p>
              Votre mariage se déroule plus loin ?
              Luxembourg, Belgique ou ailleurs en France :
              les déplacements sont possibles selon votre projet.
            </p>
          </div>

        </div>
      </section>

      {/* FAQ */}
      <section className="wedding-section wedding-faq">
        <div className="wedding-container">

          <div className="wedding-heading">
            <p className="wedding-kicker">QUESTIONS FRÉQUENTES</p>
            <h2>Avant de réserver votre photographe.</h2>
          </div>

          <div className="wedding-faq-list">

            <details>
              <summary>Combien de photos recevrons-nous ?</summary>
              <p>
                Je ne fixe pas de nombre artificiel d’images à livrer.
                Je sélectionne toutes les photographies pertinentes qui racontent
                réellement votre journée, puis je les travaille individuellement.
              </p>
            </details>

            <details>
              <summary>Peut-on faire les photos de couple un autre jour ?</summary>
              <p>
                Oui. Une séance après mariage peut être envisagée si vous souhaitez
                davantage de temps ou profiter d’une lumière et d’un lieu particuliers.
              </p>
            </details>

            <details>
              <summary>Vous déplacez-vous hors de Nancy ?</summary>
              <p>
                Oui. Je travaille dans le Grand Est et peux également me déplacer
                plus largement en France, au Luxembourg et en Belgique.
              </p>
            </details>

            <details>
              <summary>Quand devons-nous vous contacter ?</summary>
              <p>
                Dès que votre date et les principaux lieux sont connus.
                Les samedis les plus demandés peuvent être réservés longtemps
                à l’avance.
              </p>
            </details>

          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="wedding-final">
        <div className="wedding-container wedding-final-inner">

          <p className="wedding-kicker">
            VOTRE HISTOIRE
          </p>

          <h2>
            Votre mariage n’arrivera
            <span>qu’une seule fois.</span>
          </h2>

          <p>
            Racontez-moi votre projet, votre date et les lieux prévus.
            Nous verrons ensemble comment créer un reportage qui vous ressemble.
          </p>

          <Link to="/contact" className="btn-cta btn-cta-red">
            PARLER DE VOTRE MARIAGE
          </Link>

        </div>
      </section>

    </main>
  );
}